import React from 'react'

import Svg from '../svg'


export default function UpdatedIcon({width, height, color, ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--content-color') || color

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="sort" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M50,98 C24.5949015,98 4,76.509668 4,50 C4,23.490332 24.5949015,2 50,2 C75.4050985,2 96,23.490332 96,50 C96,76.509668 75.4050985,98 50,98 Z M27.7808134,65.0654184 L25.1954136,75.6928882 L35.8228834,73.1074884 L78.7139232,30.2164485 L70.6718533,22.1743786 L27.7808134,65.0654184 Z" id="Shape" fill={color || "white"}></path>
        </g>
    </Svg>
}
